import LiteYouTubeEmbed from "react-lite-youtube-embed"
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css"

const mdxComponents = {
  LiteYouTubeEmbed,
}

export default mdxComponents